import { Table, Tbody, Text, VStack } from '@chakra-ui/react'
import { Container } from '@components/Container'
import { DetailsItem, TableDetailsItem } from './TableDetailsItem/TableDetailsItem'

export type TableDetailsProps = {
  title: string
  details: DetailsItem[]
}

export const TableDetails = ({ title, details }: TableDetailsProps) => {
  return (
    <Container>
      <VStack width="100%" gridGap={{ base: '1rem', md: '1.8rem', lg: '2.5rem' }}>
        <Text fontSize={{ base: '1.5rem', md: '2rem' }} fontWeight={700} color="gray.800">
          {title}
        </Text>
        <Table variant="striped" colorScheme="gray" borderRadius={'8px'} marginTop="0px !important">
          <Tbody>
            {details.map((detail, index) => (
              <TableDetailsItem name={detail.name} value={detail.value} key={index} />
            ))}
          </Tbody>
        </Table>
      </VStack>
    </Container>
  )
}
